"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Email = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Email = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21.6 2H2.4A2.4 2.4 0 000 4.4v14.4a2.4 2.4 0 002.4 2.4h19.2a2.4 2.4 0 002.4-2.4V4.4A2.4 2.4 0 0021.6 2zm0 2.4v3.48l-8.82 6.18a1.368 1.368 0 01-1.56 0L2.4 7.88V4.4h19.2zm-19.2 6v8.4h19.2v-8.4l-7.62 5.328a3.456 3.456 0 01-3.96 0L2.4 10.4z", clipRule: "evenodd" })); };
exports.Email = Email;
//# sourceMappingURL=email.js.map